const EARLIEST_POSSIBLE_DATE = '1901-01-01';
// isabelle: this date format allows proper parsing across multipe browsers as of 2023.
// the previous format 'MM-DD-YYYY' returns as an invalid date due to Safari's lack of support for ISO 8601 format
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/parse

export default EARLIEST_POSSIBLE_DATE;
